import { SHIPPING_CONDITION_CODE } from '../../../../../../shared/constants/shipping-conditions-codes';
import { delivery } from './delivery/config';
import { pickUp } from './pick-up/config';
import { ownFreight } from './own-freight/config';

export const multiproduct = {
  [SHIPPING_CONDITION_CODE.DELIVERY]: delivery,
  [SHIPPING_CONDITION_CODE.PICK_UP]: pickUp,
  [SHIPPING_CONDITION_CODE.OWN_FREIGHT]: ownFreight,
};
